function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#FFF",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 2l-.001 2.999L40 5v51H2V5l10.999-.001L13 2h17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 2h17v8H13z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.517 28.667L9 31l8.221 8L34 22.333 31.651 20l-14.43 14.333z"
}));

var SvgClipboardWhite = function SvgClipboardWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 58,
    viewBox: "0 0 42 58"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/clipboard-white.f4c68244.svg";
export { SvgClipboardWhite as ReactComponent };